import { create } from "zustand";

interface IStore {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const useLeftMenu = create<IStore>()((set) => ({
  isOpen: false,
  setIsOpen: (isOpen) => {
    set({ isOpen });
  },
}));
